<template>

    <li class="project project--external"
        :class="'size-' + tiles"
    >

        <a :href="link" target="_blank" rel="noopener">

            <div class="project-logo">

                <img :src="logo" :alt="title">

                <div class="title">
                    <h2>{{ title }}</h2>
                </div>

            </div>

            <div class="preview">
                <img :src="preview" :alt="title + ' Preview'">
            </div>

        </a>

        <span class="blender-1"
            :style="{ background }"
        ></span>

        <span class="blender-2"
            :style="{ background }"
        ></span>

    </li>

</template>

<script>
export default {

    props: {
        tiles: {
            type: String,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        logoSuffix: {
            type: String,
            required: true
        },
        background: {
            type: String,
            required: true
        }
    },

    computed: {
        logo() {
            return require('Projects/' + this.title.toLowerCase().replace(/\s/g, '-') + '/project-logo.' + this.logoSuffix)
        },
        preview() {
            return require('Projects/' + this.title.toLowerCase().replace(/\s/g, '-') + '/project-preview.jpg')
        }
    }
}
</script>



// WEBPACK FOOTER //
// project-external.vue?0d215baa